import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import useCompanySettings from "../hooks/useSettings/companySettings";
import ClassicLayout from "./ClassicLayout";
import ModernLayout from "./ModernLayout";
import BackdropLoading from "../components/BackdropLoading";
import useIdleTimer from "../hooks/useIdleTimer";

/**
 * LoggedInLayout - Seletor de Layout
 * 
 * Este componente verifica a configuração "layoutType" da empresa
 * e carrega o layout apropriado:
 * - "modern" = Layout moderno (navbar horizontal)
 * - "classic" = Layout clássico (menu lateral)
 * 
 * A configuração pode ser alterada em:
 * Configurações → Aparência → Tipo de Layout
 */
const LoggedInLayout = (props) => {
  const { user } = useContext(AuthContext);
  const { get: getSetting } = useCompanySettings();
  const [layoutType, setLayoutType] = useState(null);
  const [loading, setLoading] = useState(true);

  // Monitorar inatividade do usuário em toda a aplicação (Idle Tracker)
  useIdleTimer();

  useEffect(() => {
    const fetchLayoutType = async () => {
      try {
        if (user?.companyId) {
          const setting = await getSetting({
            column: "layoutType"
          });
          
          // Se encontrou a configuração, usa ela
          if (setting && setting.layoutType) {
            setLayoutType(setting.layoutType);
          } else {
            // Fallback para modern se não encontrar
            setLayoutType("modern");
          }
        } else {
          // Sem companyId, usa modern
          setLayoutType("modern");
        }
      } catch (error) {
        console.log("Erro ao buscar layoutType, usando modern:", error);
        // Em caso de erro, usa modern
        setLayoutType("modern");
      } finally {
        setLoading(false);
      }
    };

    // Pequeno delay para garantir que o contexto está carregado
    const timer = setTimeout(() => {
      fetchLayoutType();
    }, 100);

    return () => clearTimeout(timer);
  }, [user?.companyId]);

  // Mostra loading enquanto busca a configuração
  if (loading || !layoutType) {
    return <BackdropLoading />;
  }

  // Renderiza o layout apropriado
  if (layoutType === "modern") {
    return <ModernLayout {...props} />;
  }

  return <ClassicLayout {...props} />;
};

export default LoggedInLayout;
